import React, { useEffect, useState } from 'react'
import { SDrawerOrModal, STriggerModal } from 'shj-components'
import { Form, Input, message, Select } from 'antd'
import { dcpAppUserSaveWithResult } from '@/services/kuAccount'

const FormItem = Form.Item
const { TextArea } = Input

interface IAddOrEditProps {
  reload?: (values: object) => void
  onClose?: (values: object) => void
  companyList?: any[]
  record?: object
  open?: boolean
}

const ModifyModalDom: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const { record, reload, onClose, companyList, open } = props

  const id = record?.id
  const [form] = Form.useForm()
  const { setFieldsValue } = form
  const isEdit = () => !!(record && record.id)

  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [data, setData] = useState<Record<string, any>>({})
  const [companies, setCompanies] = useState<any[]>([])

  const updateData = (newData: Record<string, any>) => {
    setData(newData)
    setFieldsValue(newData)
  }

  const initFn = () => {
    updateData(record)
  }

  useEffect(() => {
    if (record) {
      form.setFieldsValue({ ...record })
    }
  }, [])

  useEffect(() => {
    if (companyList.length > 0) {
      setCompanies(companyList)
    }
  }, [companyList])

  // 提交
  const onFinish = (values: any) => {
    form.validateFields().then((values: any) => {
      const requestData = { ...values, ...data }
      setSubmitLoading(true)
      const isEdited = isEdit();
      if (isEdited) {
        requestData.id = id
      }
      dcpAppUserSaveWithResult(requestData, isEdited?'dcpAppUser/updateById ':'dcpAppUser')
        .then((res: any) => {
          message.success(res?.data?.message || '操作成功')
          onClose?.()
          reload?.()
        })
        .finally(() => setSubmitLoading(false))
    })
  }

  const onChange = (val: Record<string, any>) => {
    setData({
      ...data,
      ...val,
    })
  }

  return (
    <SDrawerOrModal
      title={record?.id ? '编辑' : '新增'}
      open={open}
      cancelText="取消"
      okText="提交"
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
    >
      <Form form={form} autoComplete="off" labelAlign={'right'} layout="vertical">
        <FormItem
          label="酷家乐账号"
          name="kjlAccount"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入酷家乐账号" disabled={isEdit()} maxLength={100} showCount />
        </FormItem>
        <FormItem
          label="酷家乐账号名称"
          name="kjlName"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入酷家乐账号名称" disabled={isEdit()} maxLength={100} showCount/>
        </FormItem>
        <FormItem
          label="关联生活家账号"
          name="appuid"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入关联生活家账号" disabled={isEdit()} maxLength={100} showCount/>
        </FormItem>
        <FormItem
          label="使用门店"
          name="companyCode"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Select
            placeholder={'请选择使用门店'}
            showSearch allowClear
            filterOption={(input, option) =>
              (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {companies &&
              companies.map(company => {
                return (
                  <Select.Option key={company.id} value={company.code}>
                    {company.name}
                  </Select.Option>
                )
              })}
          </Select>
        </FormItem>
        <Form.Item label="备注" name="remark" rules={[{ required: true, message: '不能为空' }]}>
          <TextArea placeholder="请输入备注" rows={4} maxLength={200} showCount/>
        </Form.Item>
      </Form>
    </SDrawerOrModal>
  )
}

export default ModifyModalDom
